import React, { useState } from "react";

export default function Certifications() {
  const [selectedImage, setSelectedImage] = useState(null);

  const certificates = [
    {
      title: "ISO 9001:2015",
      description: "",
      image: "/images/Certifications/EU-Certificate.jpg",
    },
     {
      title: "ISO 9001:2015",
      description: "",
      image: "/images/Certifications/FSSAI-Liense.jpg",
    },
     {
      title: "ISO 9001:2015",
      description: "",
      image: "/images/Certifications/GMP_SK-BIO_2023.jpg",
    },
    {
      title: "GMP Certified",
      description: "",
      image: "/images/Certifications/NOP-Certificate.jpg",
    },
    {
      title: "FSSAI Approved",
      description: "",
      image: "/images/Certifications/NPOP-Certificate.jpg",
    },
    {
      title: "Organic Certified",
      description: "",
      image: "/images/Certifications/SK-BIO-MPL.jpg",
    },
  ];

  return (
    <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "2rem 1rem" }}>
      <h2 className="text-center mb-4">Our Certifications</h2>
      <div className="row g-4">
        {certificates.map((cert, index) => (
          <div className="col-md-6 col-lg-3" key={index}>
            <div className="card h-100 shadow-sm">
              <img
                src={cert.image}
                className="card-img-top"
                alt={cert.title}
                style={{
                  height: "350px",
                  objectFit: "contain", // full certificate visible
                  backgroundColor: "#f9f9f9",
                  padding: "10px",
                  border: "1px solid #ddd",
                  cursor: "pointer",
                }}
                onClick={() => setSelectedImage(cert.image)} // open modal
              />
              <div className="card-body text-center">
                <h5 className="card-title">{cert.title}</h5>
                <p className="card-text">{cert.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Modal for full image */}
      {selectedImage && (
        <div
          className="modal show fade"
          style={{
            display: "block",
            backgroundColor: "rgba(0,0,0,0.8)",
          }}
          onClick={() => setSelectedImage(null)}
        >
          <div
            className="modal-dialog modal-dialog-centered modal-lg"
            style={{
              display: "flex",           // make it flex
              justifyContent: "center",   // horizontal center
              alignItems: "center",       // vertical center
            }}
          >
            <div className="modal-content bg-transparent border-0">
              <img
                src={selectedImage}
                alt="Full Certificate"
                style={{
                  width: "80%",
                  height: "auto",
                  objectFit: "contain",
                  borderRadius: "8px",
                }}
              />
              
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
